import { render, staticRenderFns } from "./AppRecaptchaModal.vue?vue&type=template&id=25b89942&"
import script from "./AppRecaptchaModal.vue?vue&type=script&lang=js&"
export * from "./AppRecaptchaModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports